export const sidebarConstants = {
  UPDATE_STATUS: "UPDATE_STATUS",
  INIT_NUMBERS: "INIT_NUMBERS",
  UPDATE_SELECTIONS: "UPDATE_SELECTIONS",
  RESET_FILTER: "RESET_FILTER",
  SORT_CASES: "SORT_CASES",
  DASHBOARD: "DASHBOARD",
  CASES: "CASES",
  INVOICE_TEMPLATES: "INVOICETEMPLATES",
  INVOICE_MANAGEMENT: "INVOICE_MANAGEMENT",
  EMAIL_SETUP: "EMAIL_SETUP",
  INBOUNDEMAILS: "INBOUNDEMAILS",
  SUBSCRIPTION: "SUBSCRIPTION",
  PAYMENT_SETUP: "PAYMENT_SETUP",
  PAYMENT_REPORTS: "PAYMENT_REPORTS",
  CREDITS: "CREDITS",
  BUSINESS_DETAILS: "BUSINESS_DETAILS",
  BASE_SETTINGS: "BASE_SETTINGS",
  TRANSLATIONS: "TRANSLATIONS",
  USERS: "USERS",
  EMAIL_FLOWS: "EMAIL_FLOWS",
  CASETEMPLATES: "CASETEMPLATES",
};
